import { GetExtension } from "./GetExtension";

export function IsJPEG(fileName) {
  var ext = GetExtension(fileName);
  var isJ = false;

  switch (ext) {
    case "jpg":
      isJ = true;
      break;
  }

  return isJ;
}
